import React, { ReactChild, ReactNode, useContext, useEffect, useState } from 'react'
import PageHeader from '../../../components/Layout/PageHeader'
import VoohCampaignFormService from '../VoohCampaignForm/service'
import { useNavigate, useParams } from 'react-router-dom'
import { ReactRouterParams } from '../../../types/various'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { CampaignStatus, Medium, MediumPlacement, MediumStatus } from '../../../types/campaign'
import { Routes } from '../../../routes'
import Button, { ButtonSize, ButtonTheme } from '../../../components/Form/Button'
import { faCopy, faEdit, faFilePdf, faShare, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import CampaignUtils from '../../../utils/campaign'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FillingSpinner from '../../../components/FillingSpinner'
import Card, { CardStatus } from '../../../components/Layout/Card'
import VoohCampaignSummary from './VoohCampaignSummary'
import MediaMap from '../../../components/MediaMap'
import { VoohCampaignForm, VoohMedia, VoohMediaFormat } from '../VoohCampaignForm/types'
import VoohCampaignHistory from './VoohCampaignHistory/VoohCampaignHistory'
import CardHeader from '../../../components/Layout/CardHeader'
import VoohMediaListTable from '../VoohMediaList/VoohMediaListTable'
import { ITEMS_PER_PAGE } from '../../../constant'
import { VoohMediaPage } from './types'
import { CAMPAIGN, CAMPAIGN_ACTION } from '../../../constant/authorization'
import { AppContext } from '../../../contexts/AppContext'
import { CampaignPermissionType, FeatureName } from '../../../types/features'
import ModalAction from '../../../components/Modal/ModalAction'
import useVoohCampaignAction from '../../../hooks/useVoohCampaignAction'
import VoohCampaignRealization from './VoohCampaignRealization/VoohCampaignRealization'
import DownloadUtils from '../../../utils/download'
import { voohCampaignFormActions } from '../VoohCampaignForm/slice'
import VoohCampaignDetailsCreations from './VoohCampaignDetailsCreations/VoohCampaignDetailsCreations'
import Modal from '../../../components/Modal'
import CampaignDetailsShareUrl from '../../Campaign/CampaignDetails/CampaignDetailsShareUrl'
import CampaignDetailsNote from '../../Campaign/CampaignDetails/CampaignDetailsNote'
import VoohCampaignDetailsService from './service'

const VoohCampaignDetails: React.FC = () => {
  const { id: urlId, uuid } = useParams<ReactRouterParams>()
  const note = useSelector((state: RootState) => state.voohCampaignForm.note)
  const voohForm = useSelector((state: RootState) => state.voohCampaignForm.form)
  const publishable = useSelector((state: RootState) => state.voohCampaignForm.publishable)
  const campaignStatus = useSelector((state: RootState) => state.voohCampaignForm.status)
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [isMapCardCollapsed, setIsMapCardCollapsed] = useState<boolean>(false)
  const [postbuyLoader, setPostbuyLoader] = useState<boolean>(false)

  const [mapMedia, setMapMedia] = useState<Medium[]>([])
  const [isMediaListCollapsed, setIsMediaListCollapsed] = useState<boolean>(true)
  const [mediaPagination, setMediaPagination] = useState<VoohMediaPage>(defaultPagination)
  const { allowedFor } = useContext(AppContext)
  const [isApproveModalOpen, setIsApproveModalOpen] = useState<boolean>(false)
  const [isStopModalOpen, setIsStopModalOpen] = useState<boolean>(false)
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState<boolean>(false)
  const [refetchCampaign, setRefetchCampaign] = useState<boolean>(false)
  const [isPublishModalOpen, setIsPublishModalOpen] = useState<boolean>(false)
  const [isCopyModalOpen, setIsCopyModalOpen] = useState<boolean>(false)
  const [approveCampaignLoading, setApproveCampaignLoading] = useState<boolean>(false)
  const [stopCampaignLoading, setStopCampaignLoading] = useState<boolean>(false)
  const [removeCampaignLoading, setRemoveCampaignLoading] = useState<boolean>(false)
  const [publishCampaignLoading, setPublishCampaignLoading] = useState<boolean>(false)
  const [locationFileDownloading, setLocationFileDownloading] = useState<boolean>(false)

  const [editModalIsOpenForCampaign, setEditModalIsOpenForCampaign] = useState<boolean>(false)
  const [isLodingCopying, setIsLoadingCopying] = useState<boolean>(false)
  const [isShareUrlModalOpen, setIsShareUrlModalOpen] = useState<boolean>(false)

  const dispatch = useDispatch()

  const {
    acceptVoohCampaign,
    stopVoohCampaign,
    copyVoohCampaign,
    createVoohCampaignSummaryPdf,
    fetchPdfTaskStatus,
    removeVoohCampaign,
  } = useVoohCampaignAction()

  const { name } = voohForm.baseValues

  useEffect(() => {
    if (urlId) {
      VoohCampaignFormService.getVoohCampaign(urlId)
    }
    if (uuid) {
      VoohCampaignFormService.getVoohCampaignPublicReport(uuid)
    }
  }, [urlId, refetchCampaign, uuid])

  useEffect((): void => setActivePage(1), [voohForm.selectedMediums])

  useEffect(() => {
    return () => {
      dispatch(voohCampaignFormActions.resetCampaignForm())
    }
  }, [])

  useEffect(() => {
    setMapMedia(
      voohForm.selectedMediums.map((voohMediaNode: VoohMedia) => {
        return {
          address: voohMediaNode.address || 'to be added',
          agglomeration: {
            id: voohMediaNode.agglomeration_id?.toString() || '',
            name: voohMediaNode.agglomeration?.name || '',
          },
          asId: voohMediaNode.asId || '',
          building: {
            id: voohMediaNode.building_id?.toString() || '',
            name: voohMediaNode.name,
          },
          city: {
            id: voohMediaNode.city_id?.toString() || '',
            name: voohMediaNode.city?.name || '',
          },
          comment: '',
          id: voohMediaNode.id.toString(),
          images: [],
          lat: parseFloat(voohMediaNode.latitude || ''),
          lon: parseFloat(voohMediaNode.longitude || ''),
          mediaFormat: VoohMediaFormat.MOVE_TV,
          placement: MediumPlacement.INDOOR,
          screenCount: 1,
          status: voohMediaNode.status || MediumStatus.NOT_OPERATING,
          used: true,
          vac: 1,
          poiCategories: [],
          creationFormat: 'video',
        }
      })
    )
  }, [voohForm])

  const cards = () => (
    <>
      {Header()}
      {NoteCard(note)}
      {RealizationCard()}
      {SummaryCard()}
      {CreationsCard(voohForm, campaignStatus)}
      {MapCard()}
      {MediaListCard()}
      {!uuid && HistoryCard(voohForm)}
    </>
  )

  const setActivePage = (activePage: number) => {
    setMediaPagination({
      mediumSlice: voohForm.selectedMediums.slice(
        ITEMS_PER_PAGE * (activePage - 1),
        ITEMS_PER_PAGE * activePage
      ),
      pageNumber: activePage,
      totalMediumCount: voohForm.selectedMediums.length,
    })
  }

  const Header = (): ReactNode => {
    const status = campaignStatus

    const navigateToEditCampaign = () => {
      if (status === CampaignStatus.ACTIVE) {
        setEditModalIsOpenForCampaign(true)
        return
      }

      void navigate(Routes.VOOH_CAMPAIGNS.EDIT(voohForm.id))
    }

    const Status = (): ReactChild => {
      const parsedStatus = CampaignUtils.parseStatus(campaignStatus)

      return (
        <div
          className={`CampaignDetails__status CampaignDetails__status--${parsedStatus.iconTheme}`}
        >
          <FontAwesomeIcon
            className='CampaignDetails__status--icon'
            icon={parsedStatus.icon}
          />
          {parsedStatus.text}
        </div>
      )
    }

    return (
      <div className='CampaignDetails__header--container'>
        <PageHeader className='CampaignDetails__header'>
          {voohForm.baseValues.name}
          <div className='CampaignDetails__header--buttons'>
            {!uuid && (
              <Button
                dataCy={'copy-campaign-btn'}
                theme={ButtonTheme.NAVY_BLUE_OUTLINE}
                size={ButtonSize.SMALL}
                icon={faCopy}
                onClick={() => {
                  void setIsCopyModalOpen(true)
                }}
              >
                {t('common.createCopy')}
              </Button>
            )}

            <Button
              theme={ButtonTheme.NAVY_BLUE_OUTLINE}
              size={ButtonSize.SMALL}
              icon={faFilePdf}
              disabled={postbuyLoader}
              onClick={async () => {
                setPostbuyLoader(true)

                const createAction = await createVoohCampaignSummaryPdf(voohForm.uuid)

                if (!createAction || !createAction.data?.createVoohCampaignSummaryPdf.success) {
                  return
                }

                const jobId = createAction.data?.createVoohCampaignSummaryPdf.task.jobId

                /**
                 * a) execute service.fetchPdfTaskStatus every 5 seconds until it contains file, then stop
                 */
                const interval = setInterval(async () => {
                  const fetchAction = await fetchPdfTaskStatus(jobId)

                  if (!fetchAction || fetchAction.status === 'failed') {
                    clearInterval(interval)
                    return
                  }

                  if (fetchAction.file) {
                    clearInterval(interval)
                    setPostbuyLoader(false)
                    await DownloadUtils.downloadFileFromUrl(
                      fetchAction.file,
                      `${voohForm.baseValues.name}.pdf`
                    )
                    return
                  }
                }, 5000)

                // if interval is not cleared, clear it after 3 minutes
                setTimeout(() => {
                  clearInterval(interval)
                }, 180000)
              }}
            >
              {t('common.postbuy')}
              {postbuyLoader && <FillingSpinner className='CampaignDetails__pdf-spinner' />}
            </Button>
            {!uuid && (
              <Button
                theme={ButtonTheme.NAVY_BLUE_OUTLINE}
                size={ButtonSize.SMALL}
                icon={faEdit}
                onClick={navigateToEditCampaign}
              >
                {t('common.edit')}
              </Button>
            )}
            {!uuid && (
              <Button
                theme={ButtonTheme.NAVY_BLUE_OUTLINE}
                size={ButtonSize.SMALL}
                icon={faShare}
                dataCy={'campaign-details-share-campaign-btn'}
                onClick={() => void setIsShareUrlModalOpen(true)}
              >
                {t('common.share')}
              </Button>
            )}
            {!uuid && (
              <Button
                theme={ButtonTheme.NAVY_BLUE_OUTLINE}
                size={ButtonSize.SMALL}
                icon={faTrashAlt}
                dataCy={'remove-campaign-button'}
                onClick={() => void setIsRemoveModalOpen(true)}
              >
                {t('common.remove')}
                {removeCampaignLoading && (
                  <FillingSpinner className='CampaignDetails__remove-spinner' />
                )}
              </Button>
            )}
          </div>
        </PageHeader>

        <div className='CampaignDetails__header--second'>
          {Status()}

          <>
            {allowedFor({
              template: CAMPAIGN_ACTION.PUBLISH,
              feature: { name: FeatureName.Campaigns, action: CampaignPermissionType.Publish },
              status,
            }) &&
              !uuid && (
                <Button
                  disabled={!publishable}
                  onClick={() => void setIsPublishModalOpen(true)}
                >
                  {t('common.publishChanges')}
                </Button>
              )}

            {allowedFor({
              template: CAMPAIGN_ACTION.APPROVE,
              status,
            }) &&
              !uuid && (
                <Button onClick={() => void setIsApproveModalOpen(true)}>
                  {t('common.activateCampaign')}
                </Button>
              )}

            {allowedFor({ template: CAMPAIGN_ACTION.FINISH, status }) && !uuid && (
              <Button
                theme={ButtonTheme.BLUE_OUTLINE}
                onClick={() => void setIsStopModalOpen(true)}
              >
                {t('common.stop')}
              </Button>
            )}
          </>
        </div>
      </div>
    )
  }

  const MediaListCard = (): ReactNode => (
    <Card>
      <CardHeader
        collapsed={isMediaListCollapsed}
        onCollapse={(collapsed: boolean) => void setIsMediaListCollapsed(collapsed)}
      >
        {t('common.clubsList')}
      </CardHeader>
      {!isMediaListCollapsed && (
        <div className={'CampaignDetails__vooh-media-container'}>
          <VoohMediaListTable
            pagination={{
              activePage: mediaPagination.pageNumber,
              totalItemsCount: mediaPagination.totalMediumCount,
              setPage: setActivePage,
            }}
            media={mediaPagination.mediumSlice}
          ></VoohMediaListTable>
          <div className={'CampaignDetailsMediaList__report'}>
            <Button
              size={ButtonSize.SMALL}
              onClick={async () => {
                setLocationFileDownloading(true)
                await VoohCampaignDetailsService.fetchVoohCampaignLocationsFile(
                  uuid || urlId,
                  !!uuid
                )
                setLocationFileDownloading(false)
              }}
              disabled={locationFileDownloading}
            >
              {locationFileDownloading ? (
                <FillingSpinner className={'CampaignDetailsMediaList__spinner'} />
              ) : (
                t('campaignDetails.locationsReport')
              )}
            </Button>
          </div>
        </div>
      )}
    </Card>
  )

  const RealizationCard = (): ReactNode => (
    <Card
      id='realization'
      title={t('campaignDetails.realization.header')}
      noMarginBody
    >
      <VoohCampaignRealization></VoohCampaignRealization>
    </Card>
  )

  const SummaryCard = (): ReactNode => (
    <Card
      id='summary'
      title={t('common.campaignDetails')}
      noMarginBody
    >
      <VoohCampaignSummary voohForm={voohForm} />
    </Card>
  )

  const MapCard = (): ReactNode =>
    voohForm.selectedMediums.length > 0 && (
      <Card
        id='map-card'
        className='CampaignDetails__map--card'
        title={t('common.placementOfClubs')}
        status={CardStatus.NONE}
        isCollapsed={isMapCardCollapsed}
        onCollapse={collapsed => void setIsMapCardCollapsed(collapsed)}
        noMarginBody
      >
        {!isMapCardCollapsed && (
          <MediaMap
            className='CampaignDetails__map'
            media={mapMedia}
            withClustering
          />
        )}
      </Card>
    )

  const CreationsCard = (
    voohCampaignForm: VoohCampaignForm,
    campaignStatus: CampaignStatus
  ): ReactNode => {
    const hasCreations = voohCampaignForm.creations.length > 0

    return (
      <Card
        id='creations'
        title={t('campaignDetails.creations')}
        noMarginBody={hasCreations}
      >
        {hasCreations ? (
          <VoohCampaignDetailsCreations
            voohCampaignForm={voohCampaignForm}
            campaignStatus={campaignStatus}
          />
        ) : (
          <div className='CampaignDetails__no-creations-container'>
            {t('campaignDetails.noCreationsInfo')}
          </div>
        )}
      </Card>
    )
  }

  const HistoryCard = (campaign: VoohCampaignForm) => <VoohCampaignHistory campaign={campaign} />

  const NoteCard = (note: string): ReactNode =>
    allowedFor({ template: CAMPAIGN.NOTE }) &&
    note && (
      <CampaignDetailsNote
        note={note}
        contractNote={''}
      />
    )

  return voohForm.id ? (
    <div className='CampaignDetails'>
      {cards()}
      {isShareUrlModalOpen && voohForm.uuid && (
        <Modal
          title={t('campaignDetails.shareUrl.title')}
          isOpen={isShareUrlModalOpen}
          onClose={(isOpen: boolean) => void setIsShareUrlModalOpen(isOpen)}
          footer={
            <Button onClick={() => void setIsShareUrlModalOpen(false)}>
              {t('common.finished')}
            </Button>
          }
        >
          <CampaignDetailsShareUrl
            url={window.location.origin + Routes.VOOH_CAMPAIGNS.ONE_PUBLIC(voohForm.uuid)}
          />
        </Modal>
      )}

      {isApproveModalOpen && (
        <ModalAction
          title={t('modal.approveCampaign')}
          itemText={t('modal.doYouWantToApproveCampaign')}
          itemName={name}
          actionText={t('modal.activate')}
          isOpen={isApproveModalOpen}
          setIsOpen={setIsApproveModalOpen}
          isLoading={approveCampaignLoading}
          setIsLoading={setApproveCampaignLoading}
          onAction={() => acceptVoohCampaign(voohForm.id, 'activate')}
        />
      )}

      {isStopModalOpen && (
        <ModalAction
          title={t('modal.stoppingCampaign')}
          itemText={t('modal.doYouWantToStopCampaign')}
          descriptionText={t('modal.stopCampaignDescription')}
          actionText={t('common.stop')}
          itemName={name}
          isOpen={isStopModalOpen}
          setIsOpen={setIsStopModalOpen}
          isLoading={stopCampaignLoading}
          setIsLoading={setStopCampaignLoading}
          onAction={() => stopVoohCampaign(voohForm.id, setStopCampaignLoading, setRefetchCampaign)}
        />
      )}

      {isRemoveModalOpen && (
        <ModalAction
          title={t('modal.campaignRemoval')}
          itemText={t('modal.doYouWantToRemove')}
          actionText={t('common.remove')}
          itemName={name}
          isOpen={isRemoveModalOpen}
          isLoading={removeCampaignLoading}
          setIsLoading={setRemoveCampaignLoading}
          setIsOpen={setIsRemoveModalOpen}
          onAction={() => removeVoohCampaign(voohForm.id, setRemoveCampaignLoading)}
        />
      )}

      {isPublishModalOpen && (
        <ModalAction
          title={t('modal.publishingChanges')}
          itemText={t('modal.doYouWantToPublishCampaign')}
          itemName={name}
          actionText={t('modal.publish')}
          isOpen={isPublishModalOpen}
          setIsOpen={setIsPublishModalOpen}
          isLoading={publishCampaignLoading}
          setIsLoading={setPublishCampaignLoading}
          onAction={() => acceptVoohCampaign(voohForm.id, 'publish')}
        />
      )}

      {isCopyModalOpen && (
        <ModalAction
          title={t('modal.createCampaignCopy')}
          itemText={t('modal.doYouWantToCreateCampaignCopy')}
          itemName={voohForm.baseValues.name}
          actionText={t('modal.createCopy')}
          isOpen={isCopyModalOpen}
          isLoading={isLodingCopying}
          setIsLoading={setIsLoadingCopying}
          setIsOpen={setIsCopyModalOpen}
          onAction={() => copyVoohCampaign(voohForm.id, setIsLoadingCopying)}
        />
      )}

      {editModalIsOpenForCampaign && (
        <ModalAction
          title={t('modal.campaignEditing')}
          contentText={t('modal.editCampaignInfo')}
          itemText={t('modal.doYouWant')}
          itemName={t('modal.editCampaignItem')}
          actionText={t('common.edit')}
          isOpen={editModalIsOpenForCampaign}
          setIsOpen={setEditModalIsOpenForCampaign}
          onAction={() => new Promise(() => void navigate(Routes.VOOH_CAMPAIGNS.EDIT(voohForm.id)))}
        />
      )}
    </div>
  ) : (
    <FillingSpinner />
  )
}

const defaultPagination = {
  pageNumber: 1,
  totalMediumCount: 0,
  mediumSlice: [],
}

export default VoohCampaignDetails
